import { env } from '../App/config/env';
import { storeAppID } from './storeAppID';

export function setAppID(appID: string) {
  storeAppID(appID);

  env.APP_ID = appID;
}
